import { render, staticRenderFns } from "./UcCompactRentalDisplay.yaml?vue&type=template&id=4c65713e&component"
import script from "./UcCompactRentalDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompactRentalDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports